import { StyleSheet, Image } from "react-native";
import { View } from "../shared/Themed";
import { useAppTheme } from "../../hooks/useAppTheme";

export default function CompanyLogo() {
  const { isDark } = useAppTheme();
  
  return (
    <View style={[styles.box, { backgroundColor: "transparent" }]}>
      <Image
        style={styles.tinyLogo}
        resizeMode="contain"
        source={isDark ? require("../../assets/iconDark.png") : require("../../assets/iconLight.png")}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    height: 45,
    marginTop: 15,
    position: "absolute",
  },
  tinyLogo: {
    width: 50,
    height: 30,
  },
});
